<template>
  <div class="aaaaa">


    <div v-if="showHome">
      <addGoodPage @goBack="goBack" :activeTabNum="activeTabNum" ></addGoodPage>
    </div>

    <div class="bbbbb" v-else>
      <el-row :gutter="20">
        <el-col :span="8" class="item" v-for="(item,index) in list" :key="index">
          <el-card class="box-card" style="margin-bottom: 20px">
            <el-row type="flex" style="height: 160px; padding: 20px; box-sizing: border-box ">
              <el-image :src="item.icon" fit="cover" style="width: 50px;height: 50px;"></el-image>
              <div style="margin-left: 10px">
                <div class="title">{{item.name}}</div>
                <div class="desc">{{item.desc}}</div>
              </div>
            </el-row>
            <el-button @click="addActivity(item.value)" class="btn" type="text">创建 <i class="el-icon-plus"></i> </el-button>


          </el-card>

        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import addGoodPage from "@/views/productActivity/components/addGoodPage.vue";

export default {
  name: "activityList",
  components: {addGoodPage},
  data () {
    return {
      list:[
        {
          name: '今日优惠',
          value: '1',
          icon:"https://stjnfile.duochicai.com/resources/upload/2025-01-02/file_202501027722687670501.png",
          desc:"展示当天有优惠活动的商品专区"
        },
        {
          name: '新品展示',
          value: '2',
          icon:"https://stjnfile.duochicai.com/resources/upload/2025-01-02/file_202501027722687670501.png",
          desc:"展示新推出的商品"
        },
        {
          name: '爆款专区',
          value: '3',
          icon:"https://stjnfile.duochicai.com/resources/upload/2025-01-02/file_202501027722687670501.png",
          desc:"聚焦于平台上的热门、畅销商品"
        },
        {
          name: '新人专享管理',
          value: '4',
          icon:"https://stjnfile.duochicai.com/resources/upload/2025-01-02/file_202501027722687670501.png",
          desc:"专为新用户设置的区域，提供新用户专享的商品或服务"
        },
        {
          name: '好物推荐管理',
          value: '5',
          icon:"https://stjnfile.duochicai.com/resources/upload/2025-01-02/file_202501027722687670501.png",
          desc:"推荐平台上值得购买的优质商品"
        },
        {
          name: '会员管理',
          value: '6',
          icon:"https://stjnfile.duochicai.com/resources/upload/2025-01-02/file_202501027722687670501.png",
          desc:"针对平台会员的管理和服务模块"
        },
        {
          name: '团购专区管理',
          value: '7',
          icon:"https://stjnfile.duochicai.com/resources/upload/2025-01-02/file_202501027722687670501.png",
          desc:"用于组织和管理团购活动，用户可以在这里参与团购以获取更优惠的价格"
        },
        {
          name: '砍价专区',
          value: '8',
          icon:"https://stjnfile.duochicai.com/resources/upload/2025-01-02/file_202501027722687670501.png",
          desc:"用户可以在此发起或参与砍价活动，通过邀请好友帮忙砍价来降低商品价格"
        },
        {
          name: '秒杀',
          value: '9',
          icon:"https://stjnfile.duochicai.com/resources/upload/2025-01-02/file_202501027722687670501.png",
          desc:"开展限时秒杀活动，用户在规定时间内以优惠价格抢购商品"
        }
      ],
      showHome:false
    }
  },
  methods: {
    goBack () {
      this.showHome = false
    },
    addActivity (val) {

      if(val==9){
        // addSeckillProduct
        this.$router.push('/addSeckillProduct')
      }else {
        this.activeTabNum = val
        this.showHome = true
      }


    },
  },
  created () {

  }
}
</script>

<style scoped lang="scss">
.desc {
  margin-top: 10px;
  font-size: 14px;
  color: #a9a9a9;
}

::v-deep .el-card__body, .el-main {
  padding: 0 !important;
}

.btn {
  width: 100% !important;
  background: #fafafa !important;
  color: #726e84 !important;
  height: 40px !important;
}
</style>
